import React from 'react'
import { Teams } from '../../component/Teams'

export const TeamsPage = () => {
  return (
    <Teams />
  )
}
